import md5 from 'md5';

function useCompanyVariant(canonicalUrlWithSection: string): string {
  if (!canonicalUrlWithSection) return '0';
  const hash: string = md5(canonicalUrlWithSection);
  //This value is a hexadecimal: 0,1,2,3,4,5,6,7, 8,9,a,b,c,d,e,f
  const least = hash.slice(hash.length - 1);

  return least;
}

export default useCompanyVariant;
